export const CITY_MAP = [
  {
    label: '上海市',
    value: '上海市',
    children: [{ label: '上海市', value: '上海市' }],
  },
  {
    label: '浙江省',
    value: '浙江省',
    children: [
      { label: '杭州市', value: '杭州市' },
      { label: '宁波市', value: '宁波市' },
      { label: '温州市', value: '温州市' },
      { label: '嘉兴市', value: '嘉兴市' },
      { label: '湖州市', value: '湖州市' },
      { label: '绍兴市', value: '绍兴市' },
      { label: '金华市', value: '金华市' },
      { label: '衢州市', value: '衢州市' },
      { label: '舟山市', value: '舟山市' },
      { label: '台州市', value: '台州市' },
      { label: '丽水市', value: '丽水市' },
    ],
  },
  {
    label: '江苏省',
    value: '江苏省',
    children: [
      { label: '南京市', value: '南京市' },
      { label: '无锡市', value: '无锡市' },
      { label: '徐州市', value: '徐州市' },
      { label: '常州市', value: '常州市' },
      { label: '苏州市', value: '苏州市' },
      { label: '南通市', value: '南通市' },
      { label: '连云港市', value: '连云港市' },
      { label: '淮安市', value: '淮安市' },
      { label: '盐城市', value: '盐城市' },
      { label: '扬州市', value: '扬州市' },
      { label: '镇江市', value: '镇江市' },
      { label: '泰州市', value: '泰州市' },
      { label: '宿迁市', value: '宿迁市' },
    ],
  },

  {
    label: '江西省',
    value: '江西省',
    children: [
      {
        label: '南昌市',
        value: '南昌市',
      },
      {
        label: '赣州市',
        value: '赣州市',
      },
      {
        label: '新余市',
        value: '新余市',
      },
      {
        label: '吉安市',
        value: '吉安市',
      },
      {
        label: '抚州市',
        value: '抚州市',
      },
      {
        label: '鹰潭市',
        value: '鹰潭市',
      },
      {
        label: '景德镇市',
        value: '景德镇市',
      },
      {
        label: '九江市',
        value: '九江市',
      },
      {
        label: '宜春市',
        value: '宜春市',
      },
      {
        label: '萍乡市',
        value: '萍乡市',
      },
      {
        label: '上饶市',
        value: '上饶市',
      },
    ],
  },
  {
    label: '山西省',
    value: '山西省',
    children: [
      {
        label: '阳泉市',
        value: '阳泉市',
      },
      {
        label: '大同市',
        value: '大同市',
      },
      {
        label: '吕梁市',
        value: '吕梁市',
      },
      {
        label: '太原市',
        value: '太原市',
      },
      {
        label: '运城市',
        value: '运城市',
      },
      {
        label: '晋城市',
        value: '晋城市',
      },
      {
        label: '长治市',
        value: '长治市',
      },
      {
        label: '临汾市',
        value: '临汾市',
      },
      {
        label: '晋中市',
        value: '晋中市',
      },
      {
        label: '朔州市',
        value: '朔州市',
      },
      {
        label: '忻州市',
        value: '忻州市',
      },
    ],
  },
];
